import React from "react";
import { Row, Col, Badge } from "reactstrap";
import { useSelector } from "react-redux";

const DatosFacturacion = ({ metadata }) => {
  const theme = useSelector((state) => state.theme.theme) || "light";

  // Función para formatear las claves de manera más legible
  const formatKey = (key) => {
    return key
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  // Función para renderizar un valor de manera segura
  const renderValue = (value) => {
    if (value === null || value === undefined) {
      return <span className="text-muted font-italic">No especificado</span>;
    }

    // Si es un objeto, convertirlo a string JSON
    if (typeof value === 'object') {
      try {
        return (
          <pre className="bg-light p-2 rounded small text-secondary border mb-0" style={{ maxHeight: '200px', overflowY: 'auto' }}>
            {JSON.stringify(value, null, 2)}
          </pre>
        );
      } catch (error) {
        return <span className="text-danger">Objeto no válido</span>;
      }
    }

    if (value === "") {
      return <span className="text-muted font-italic">No especificado</span>;
    }

    return String(value);
  };

  // Función para renderizar una sección de datos
  const renderSection = (title, data, icon, badgeColor = "primary") => {
    if (!data || typeof data !== 'object' || Object.keys(data).length === 0) {
      return null;
    }

    const dataEntries = Object.entries(data);
    const totalFields = dataEntries.length;

    return (
      <div className="vb-section-card mb-4">
        <div className="vb-card-header justify-content-between">
          <div className="d-flex align-items-center gap-2">
            <i className={icon}></i>
            <span>{title}</span>
          </div>
          <Badge color={badgeColor} pill className="px-3">
            {totalFields} campo{totalFields !== 1 ? 's' : ''}
          </Badge>
        </div>

        <div className="vb-card-body">
          <Row className="g-3">
            {dataEntries.map(([key, value]) => (
              <Col lg={6} md={6} sm={12} key={key}>
                <div className="p-3 border rounded h-100 bg-light-subtle">
                  <div className="vb-field-label mb-2 text-primary" style={{ fontSize: '0.75rem' }}>
                    {formatKey(key)}
                  </div>
                  <div className="vb-field-value text-break">
                    {renderValue(value)}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    );
  };

  if (!metadata || typeof metadata !== 'object') {
    return (
      <div className="vb-empty-data">
        <i className="fas fa-file-invoice-dollar"></i>
        <h5>Sin Datos de Facturación</h5>
        <p>Este caso no contiene información de facturación en este momento.</p>
      </div>
    );
  }

  const hasData = metadata.carga_radicados || metadata.datos_basicos_facturacion || Object.keys(metadata).length > 0;

  if (!hasData) {
    return (
      <div className="vb-empty-data">
        <i className="fas fa-file-invoice-dollar"></i>
        <h5>Sin Datos de Facturación</h5>
        <p>Este caso no contiene información de facturación en este momento.</p>
      </div>
    );
  }

  return (
    <div className="vb-scroll-container" data-theme={theme}>

      {/* Carga de Radicados */}
      {metadata.carga_radicados && renderSection(
        "Información de Radicados",
        metadata.carga_radicados,
        "fas fa-file-alt",
        "info"
      )}

      {/* Datos Básicos de Facturación */}
      {metadata.datos_basicos_facturacion && renderSection(
        "Datos Básicos de Facturación",
        metadata.datos_basicos_facturacion,
        "fas fa-file-invoice-dollar",
        "success"
      )}

      {/* Si hay otros datos en metadata que no están en las secciones anteriores */}
      {(() => {
        const otherData = { ...metadata };
        delete otherData.carga_radicados;
        delete otherData.datos_basicos_facturacion;

        if (Object.keys(otherData).length > 0) {
          return renderSection(
            "Información Adicional",
            otherData,
            "fas fa-info-circle",
            "secondary"
          );
        }
        return null;
      })()}

      {/* Si no hay datos en ninguna sección específica pero metadata no está vacío (caso raro cubierto arriba pero por seguridad) */}
      {(!metadata.carga_radicados &&
        !metadata.datos_basicos_facturacion &&
        Object.keys(metadata).length === 0) && (
          <div className="vb-empty-data">
            <i className="fas fa-file-invoice-dollar"></i>
            <h5>Sin Datos de Facturación</h5>
          </div>
        )}
    </div>
  );
};

export default DatosFacturacion;